"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D2FF1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.395 12.957c-.61-.083-1.12.278-1.426.709a4416.484 4416.484 0 0 0-10.228 14.45c-.302.428-.54.765-.7.994l-.032.045-.502-.552a525.041 525.041 0 0 0-1.96-2.141c-1.61-1.748-2.863-3.018-4.892-5.129-.527-.55-1.364-.8-2.086-.387a5.925 5.925 0 0 0-1.522 1.237c-.586.671-.453 1.62.051 2.254 3.838 4.825 6.723 7.61 8.988 9.769a3.005 3.005 0 0 0 4.472-.319c2.116-2.675 6.109-7.95 12.404-17.105.404-.587.527-1.406.093-2.052-.86-1.285-1.932-1.674-2.66-1.773Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgSuccess);
var _default = exports["default"] = Memo;